import React, { FC, useCallback, useMemo } from 'react';
import UploadWithSampleModal from '../flatfile/UploadWithSampleModal';
import {
	getFlatfileRecordForPart,
	PART_MASTER_FLATFILE_HEADER,
	PARTS_MASTER_LIST_PARTIAL_FLATFILE_HEADER,
} from '../stock_locations_detail_details_page/stock_location_constants';
import { getCurrency } from '../../utils/DataAccessUtils';
import { CSV_EXPORT_DEFAULTS } from '../../utils/DataConstants';
import { connect } from 'react-redux';
import { ExportToCsv } from 'export-to-csv';
import { requiredWithValueRecordHook } from '../flatfile/faltfile_utils';
import { isGLCodeAllowedBySettings } from '../../utils/InventoryUtils';

const PartialPartsUpload: FC<any> = ({
	hideUploadPopup,
	vendorOptions,
	onDataUpload,

	currentUser,
	companyConfig,
}): React.ReactElement => {
	const userCurrency = useMemo(() => getCurrency({ currentUser }).id, [currentUser]);

	const glCodeEnabled = useMemo(() => isGLCodeAllowedBySettings(companyConfig), [companyConfig]);

	const headerDefs = useMemo(
		() => PART_MASTER_FLATFILE_HEADER([userCurrency], vendorOptions, glCodeEnabled),
		[userCurrency, vendorOptions, glCodeEnabled]
	);

	const onDownloadSample = useCallback(() => {
		const csvTitle = `Partial_Parts_Upload_Sample`;

		const csvExporter = new ExportToCsv({
			...CSV_EXPORT_DEFAULTS,
			filename: csvTitle,
			title: csvTitle,
			headers: headerDefs.map((h) => h.label),
		});

		const data = [
			{
				crudAction: 'create',
				...getFlatfileRecordForPart({}, userCurrency, headerDefs),
			},
			{
				crudAction: 'update',
				...getFlatfileRecordForPart({ id: 1234 }, userCurrency, headerDefs),
			},
			{
				crudAction: 'delete',
				...getFlatfileRecordForPart({ id: 1234 }, userCurrency, headerDefs),
			},
		];
		csvExporter.generateCsv(data);
	}, [glCodeEnabled, userCurrency, vendorOptions]);

	const recordHook = (record) => {
		return requiredWithValueRecordHook(['id'], 'crudAction', ['update', 'delete'])(record);
	};

	return (
		<UploadWithSampleModal
			type="Partial Parts Upload"
			title="Partial Parts Upload"
			downloadText="Do you want to download Sample?"
			sampleFileText="Download Sample"
			recordHook={recordHook}
			onCancel={hideUploadPopup}
			onDownloadSample={onDownloadSample}
			fields={PARTS_MASTER_LIST_PARTIAL_FLATFILE_HEADER(
				[userCurrency],
				vendorOptions,
				glCodeEnabled
			)}
			onDataLoad={onDataUpload}
		/>
	);
};

const mapStateToProps = (state) => ({
	currentUser: state.session.currentUser,
	companyConfig: state.company_config.detail,
});

export default connect(mapStateToProps)(PartialPartsUpload);
